<template>
  <v-row class="pr-10 pl-1">
    <v-col v-if="showTitle">
      <h3 class="text-subtitle-2 font-weight-bold">
        {{this.title}}
      </h3>
    </v-col>
    <v-spacer />
    <v-col
      v-show="showInfoButton"
      cols="1"
    >
      <filter-title-button
        :show="showInfoButton"
        :options="infoButtonDefinition"
        @toggle="emitToggleEvent"
      />
    </v-col>
    <v-col
      v-show="showSettingsButton"
      cols="1"
    >
      <filter-title-button
        :show="showSettingsButton"
        :options="settingsButtonDefinition"
        @toggle="emitToggleEvent"
      />
    </v-col>
    <v-col
      v-show="showResetButton"
      cols="1"
    >
      <filter-title-button
        :show="showResetButton"
        :options="resetButtonDefinition"
        @toggle="emitToggleEvent"
      />
    </v-col>

  </v-row>
</template>

<script>
import FilterTitleButton from './FilterTitleButton.vue';
export default {
  name: "filter-title",
  data () {
    return {
      settingsButtonActive: false,
      infoEnabled: false,
      infoButtonDefinition:
      {
        icon: "mdi-information-outline",
        tooltipHideText: "Skjul info om filteret " + this.title.toLowerCase(),
        tooltipShowText: "Vis info om filteret " + this.title.toLowerCase(),
        clickEventName: "toggle-description",
        toggle: true
      },
      settingsButtonDefinition:
      {
        icon: "mdi-cog-outline",
        tooltipHideText: "Skjul innstillinger for " + this.title.toLowerCase() + " filteret",
        tooltipShowText: "Vis innstillinger for " + this.title.toLowerCase() + " filteret",
        clickEventName: "toggle-settings",
        toggle: true
      },
      resetButtonDefinition:
      {
        icon: "mdi-undo-variant",
        tooltipHideText: "Tilbakestill filter for " + this.title.toLowerCase(),
        tooltipShowText: "Tilbakestill filter for " + this.title.toLowerCase(),
        clickEventName: "filter-reset",
        toggle: false
      }
    };
  },
  components: {
    FilterTitleButton
  },
  props: {
    show: Boolean,
    showSettingsButton: {
      type: Boolean,
      default: true
    },
    showResetButton: {
      type: Boolean,
      default: true
    },
    showInfoButton: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    title: String
  },
  methods: {
    emitToggleEvent: function (evt) {
      this.$emit(evt);
    }
  }
};
</script>

<style>
</style>

